// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"SectionNewsletter_formTitle__210wm"};